import React, { useState, useEffect } from "react";
import logoImage from "../assets/images/Lincoln MKT.png"; // Modern import of the logo

// Global control variable to prevent multiple renders of the NavBar
let hasRendered = false;

const NavBar = () => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [emailHovered, setEmailHovered] = useState(false);
  const [phoneHovered, setPhoneHovered] = useState(false);
  const [servicesHovered, setServicesHovered] = useState(false);
  const [dropdownHovered, setDropdownHovered] = useState(false);

  useEffect(() => {
    if (!hasRendered) {
      hasRendered = true;
      setShouldRender(true);
    }
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!shouldRender) return null;

  const styles = {
    navContainer: {
      width: "100%",
      backgroundColor: "#f2f2f2",
      paddingBottom: "20px",
      transition: "all 0.3s ease",
    },
    stickyNavContainer: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 999,
      boxShadow: "0px 8px 16px rgba(0,0,0,0.3)",
    },
    innerContainer: {
      width: "90%",
      margin: "20px auto",
    },
    whiteHeader: {
      backgroundColor: "#ffffff",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.2)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      transition: "all 0.3s ease",
    },
    stickyWhiteHeader: {
      padding: "10px 20px",
    },
    logoContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    logo: {
      width: "60px",
      height: "auto",
      filter: "brightness(1.1)",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
      transition: "all 0.3s ease",
    },
    stickyLogo: {
      transform: "translateY(10px)",
    },
    logoTextContainer: {
      display: "flex",
      flexDirection: "column",
    },
    logoText: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#0d2b3e",
      margin: "0",
    },
    subText: {
      fontSize: "14px",
      color: "#555",
      margin: "0",
    },
    contactInfoWhite: {
      display: "flex",
      gap: "20px",
      alignItems: "center",
    },
    contactCard: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      border: "1px solid #0d2b3e",
      borderRadius: "5px",
      padding: "12px 20px",
      boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.3)",
      transition: "all 0.3s ease",
    },
    contactCardHover: {
      backgroundColor: "#0d2b3e",
      border: "1px solid #ffffff",
    },
    label: {
      fontSize: "16px",
      fontWeight: "bold",
      color: "#0d2b3e",
      marginRight: "5px",
    },
    contactText: {
      fontSize: "16px",
      color: "#0d2b3e",
    },
    icon: {
      fontSize: "20px",
      color: "#0d2b3e",
      textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
    },
    blueBar: {
      backgroundColor: "#0d2b3e",
      marginTop: "10px",
      padding: "20px 50px",
      borderRadius: "10px",
      display: "flex",
      justifyContent: "center",
    },
    navLinks: {
      listStyleType: "none",
      display: "flex",
      gap: "40px",
      margin: 0,
      padding: 0,
    },
    link: {
      textDecoration: "none",
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "18px",
    },
    activeLink: {
      textDecoration: "none",
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "18px",
      padding: "10px 20px",
      borderRadius: "8px",
      borderBottom: "3px solid #0d2b3e",
    },
    dropdownContainer: {
      position: "relative",
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: dropdownHovered ? "rgba(255, 255, 255, 0.95)" : "rgba(255, 255, 255, 0.85)",
      padding: dropdownHovered ? "15px 20px" : "10px 15px",
      border: "1px solid #0d2b3e",
      borderRadius: "12px",
      boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
      zIndex: 1000,
      minWidth: "250px",
      transition: "all 0.3s ease",
    },
    dropdownItem: {
      margin: "8px 0",
      fontSize: "16px",
      color: "#0d2b3e",
      cursor: "pointer",
      padding: "5px 10px",
      borderRadius: "5px",
      transition: "background-color 0.3s ease, color 0.3s ease",
    },
  };

  return (
    <div style={{ ...styles.navContainer, ...(isSticky ? styles.stickyNavContainer : {}) }}>
      <div style={styles.innerContainer}>
        {/* White Header: Logo and Contact Info */}
        <div style={{ ...styles.whiteHeader, ...(isSticky ? styles.stickyWhiteHeader : {}) }}>
          <div style={styles.logoContainer}>
            <img
              src={logoImage}
              alt="Jet Black Logo"
              style={{ ...styles.logo, ...(isSticky ? styles.stickyLogo : {}) }}
            />
            <div style={styles.logoTextContainer}>
              <h1 style={styles.logoText}>Jet Black</h1>
              <p style={styles.subText}>Luxury Car Service</p>
            </div>
          </div>
          <div style={styles.contactInfoWhite}>
            <div
              style={{ ...styles.contactCard, ...(emailHovered ? styles.contactCardHover : {}) }}
              onMouseEnter={() => setEmailHovered(true)}
              onMouseLeave={() => setEmailHovered(false)}
            >
              <span style={{ ...styles.label, color: emailHovered ? "#ffffff" : "#0d2b3e" }}>
                Email:
              </span>
              <span style={{ ...styles.icon, color: emailHovered ? "#ffffff" : "#0d2b3e" }}>
                📧
              </span>
              <span style={{ ...styles.contactText, color: emailHovered ? "#ffffff" : "#0d2b3e" }}>
                jetblacklimo@aol.com
              </span>
            </div>
            <div
              style={{ ...styles.contactCard, ...(phoneHovered ? styles.contactCardHover : {}) }}
              onMouseEnter={() => setPhoneHovered(true)}
              onMouseLeave={() => setPhoneHovered(false)}
            >
              <span style={{ ...styles.label, color: phoneHovered ? "#ffffff" : "#0d2b3e" }}>
                Tel:
              </span>
              <span style={styles.icon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill={phoneHovered ? "#ffffff" : "#0d2b3e"}
                  viewBox="0 0 16 16"
                >
                  <path d="M3.654 1.328a.678.678 0 0 1 .738-.137l2.646 1.06a.678.678 0 0 1 .36.832l-.648 2.594a.678.678 0 0 1-.488.49l-1.42.354a11.72 11.72 0 0 0 5.516 5.516l.354-1.42a.678.678 0 0 1 .49-.488l2.594-.648a.678.678 0 0 1 .832.36l1.06 2.646a.678.678 0 0 1-.137.738l-2.306 2.306a.678.678 0 0 1-.635.164c-2.03-.61-3.892-1.813-5.515-3.437C2.16 8.52.957 6.658.347 4.628a.678.678 0 0 1 .164-.635L2.817 1.687z" />
                </svg>
              </span>
              <span style={{ ...styles.contactText, color: phoneHovered ? "#ffffff" : "#0d2b3e" }}>
                +1 (914) 962-8444
              </span>
            </div>
          </div>
        </div>

        {/* Blue Bar: Navigation Menu */}
        <div style={styles.blueBar}>
          <ul style={styles.navLinks}>
            <li>
              <a href="/" style={styles.link}>
                Home
              </a>
            </li>
            <li>
              <a href="/fleet" style={styles.link}>
                Fleet
              </a>
            </li>
            <li>
              <a href="/reservations" style={styles.link}>
                Reservations
              </a>
            </li>
            <li>
              <a href="/faq" style={styles.link}>
                FAQs
              </a>
            </li>
            {/* Dropdown for Services */}
            <li
              style={styles.dropdownContainer}
              onMouseEnter={() => {
                setServicesHovered(true);
                setDropdownHovered(true);
              }}
              onMouseLeave={() => {
                setServicesHovered(false);
                setDropdownHovered(false);
              }}
            >
              <a href="/services" style={styles.link}>
                Services
              </a>
              {servicesHovered && (
                <div
                  style={{
                    ...styles.dropdown,
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: dropdownHovered
                      ? "rgba(255, 255, 255, 0.95)"
                      : "rgba(255, 255, 255, 0.85)",
                    padding: dropdownHovered ? "15px 20px" : "10px 15px",
                  }}
                >
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Wedding Luxury Car Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Corporate Transfer Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Point to Point Transfer Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Prom Car Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Airport Transfer Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Private Transfer Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Night Tour Car Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Party Car Service
                  </p>
                  <p style={{ ...styles.dropdownItem, color: "#0d2b3e" }}>
                    Car & Chauffeur Service
                  </p>
                </div>
              )}
            </li>
            {/* Contact Link: Redirects to http://localhost:3000/info */}
            <li>
              <a href="http://localhost:3000/info" style={styles.link}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
